import React, { useEffect, useRef, useCallback } from 'react';
import Modal from 'react-modal';
import clsx from 'clsx';
import { getMaterialIconForLevel } from './LuiBanner';

interface ILuiModal {
  key?: string;
  shouldCloseOnOverlayClick?: boolean;
  onClose?: () => void;
  className?: string;
  maxWidth?: boolean;
  headingText?: string;
  lowContrast?: boolean;
}

export const LuiModal: React.FC<ILuiModal> = (props) => {
  const node = useRef(null);

  const handleClickOutside = useCallback(
    (e: any) => {
      // current DOES have a contains!
      if (node?.current && (node.current as any).contains(e.target)) {
        // inside click
        return;
      }
      // outside click
      if (props.shouldCloseOnOverlayClick) {
        props.onClose && props.onClose();
      }
    },
    [props]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  let isTest = false;

  // this is here for the tests
  if (process !== undefined) {
    isTest = process?.env?.NODE_ENV === 'test';
    if (!isTest) {
      Modal.setAppElement('#root');
    }
  }

  return (
    <Modal
      key={props.key}
      isOpen={true}
      shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
      onRequestClose={props.onClose}
      overlayClassName="modal"
      className={props.lowContrast ? 'lui-scrim-low-contrast' : 'lui-scrim'}
      ariaHideApp={!isTest} // required to prevent warnings that are not applicable in real usage
    >
      <div
        ref={node}
        className={clsx(
          'lui-modal lui-box-shadow',
          props.maxWidth && 'lui-max-width',
          props.headingText && 'lui-modal-no-padding',
          props.className
        )}
      >
        {props.headingText && (
          <LuiModalHeader
            headingText={props.headingText}
            onClose={props.onClose}
          />
        )}
        <div className={clsx(props.headingText && 'lui-modal-container')}>
          {props.children}
        </div>
      </div>
    </Modal>
  );
};

export const LuiAlertModal: React.FC<
  { level: 'success' | 'info' | 'warning' | 'error' } & ILuiModal
> = (props) => {
  let materialIcon = getMaterialIconForLevel(props.level);
  return (
    <LuiModal
      key={props.key}
      shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
      onClose={props.onClose}
      className={clsx(`lui-modal-${props.level}`, props.className)}
    >
      <i className="lui-msg-status-icon material-icons-round">{materialIcon}</i>
      {props.children}
    </LuiModal>
  );
};

export const LuiAlertModalButtons: React.FC = (props) => {
  return <div className="modal-btn-row">{props.children}</div>;
};

interface IModalHeader {
  headingText?: string;
  onClose?: () => void;
}

export const LuiModalHeader: React.FC<IModalHeader> = (props) => {
  return (
    <header className="lui-modal-header">
      {props.headingText && (
        <div className="lui-modal-header-title">
          <h1>{props.headingText}</h1>
          {props.onClose && (
            <button
              className="lui-modal-header-close-btn"
              onClick={props.onClose}
            >
              <i className="material-icons-round lui-modal-header-btn-size">
                close
              </i>
            </button>
          )}
        </div>
      )}
    </header>
  );
};
